import {
	adminMediaKitById,
	adminMediaKitCreate,
	adminMediaKitDestroy,
	adminMediaKitList,
	adminMediaKitTogglePublish,
} from '@/services/agency/media-kits.admin.service'

export default {
	namespaced: true,
	state: {
		mediaKitList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		mediaKit: {},
		listStatus: 'init',
		saveStatus: 'init',
		deleteStatus: 'init',
	},
	getters: {
		getMediaKitList(state) {
			return state.mediaKitList
		},
		getMediaKit(state) {
			return state.mediaKit
		},
		getMediaKitListStatus(state) {
			return state.listStatus
		},
		getMediaKitSaveStatus(state) {
			return state.saveStatus
		},
		getMediaKitDeleteStatus(state) {
			return state.deleteStatus
		},
	},
	mutations: {
		MEDIA_KIT_LIST(state, value) {
			state.mediaKitList = value
		},
		MEDIA_KIT(state, value) {
			state.mediaKit = value
		},
		MEDIA_KIT_LIST_STATUS(state, value) {
			state.listStatus = value
		},
		MEDIA_KIT_SAVE_STATUS(state, value) {
			state.saveStatus = value
		},
		MEDIA_KIT_DELETE_STATUS(state, value) {
			state.deleteStatus = value
		},
	},
	actions: {
		async fetchMediaKitList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('MEDIA_KIT_LIST_STATUS', 'pending')
			commit('MEDIA_KIT_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await adminMediaKitList(params)
				commit('MEDIA_KIT_LIST_STATUS', 'init')
				commit('MEDIA_KIT_LIST', data)
				return data
			} catch (error) {
				commit('MEDIA_KIT_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchMediaKit({ commit }, id) {
			commit('MEDIA_KIT_LIST_STATUS', 'pending')
			try {
				const { data } = await adminMediaKitById(id)
				commit('MEDIA_KIT_LIST_STATUS', 'init')
				commit('MEDIA_KIT', data.data)
				return data
			} catch (error) {
				commit('MEDIA_KIT_LIST_STATUS', 'init')
				return error
			}
		},
		async createMediaKit({ commit }, params) {
			commit('MEDIA_KIT_SAVE_STATUS', 'pending')
			try {
				const { data } = await adminMediaKitCreate(params)
				commit('MEDIA_KIT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MEDIA_KIT_SAVE_STATUS', 'error')
				throw error
			}
		},
		async toggleMediaKitPublish({ commit }, id) {
			commit('MEDIA_KIT_SAVE_STATUS', 'pending')
			try {
				const { data } = await adminMediaKitTogglePublish(id)
				commit('MEDIA_KIT_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MEDIA_KIT_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteMediaKit({ commit }, id) {
			commit('MEDIA_KIT_DELETE_STATUS', 'pending')
			try {
				const { data } = await adminMediaKitDestroy(id)
				commit('MEDIA_KIT_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('MEDIA_KIT_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
